// extracted by mini-css-extract-plugin
module.exports = {"learnMore":"FinalOffer_learnMore__10UPK","price":"FinalOffer_price__kJyNa"};